export const limits = {
  min: 0,
  max: 5000000,
  secs: 3,
};

export const VMS = {
  min: 0,
  max: 1500,
  default: 100,
};

export const values = {
  botsPerWeek: 166,
};

export const NumberOfHoursPerWeek = {
  min: 1,
  max: 200,
  default: 60,
};

export const FullTimeEmployeeCost = {
  min: 10,
  max: 200,
  default: 50,
};

export const ErrorRate = {
  min: 0,
  max: 100,
  default: 10,
};

export const NumberOfBusinessProcessToAutomate = {
  min: 1,
  max: 20,
  default: 10,
};

// UT30 is an unique code to identify each widget in the BPPR ecosystem
export const UT30RPAROI = '30AKY';
